export default {
  experimentId: '255',
  submissionUrl: 'https://magpie-demo.herokuapp.com/api/submit_experiment/',
  socketUrl: 'wss://magpie-demo.herokuapp.com/socket',
  contactEmail: 'test@random.com'
};
